import axios from 'axios';
export const GET_LINKEDIN_CREDENTIAL_QUERY_STRING_PARAMETERS = {
    AUTHORIZATION_CODE: 'code',
};
export const getLinkedinCredential = async (root, code) => axios
    .get(`${root}/legacy/social-media-bridge/linkedin`, {
    params: {
        [GET_LINKEDIN_CREDENTIAL_QUERY_STRING_PARAMETERS.AUTHORIZATION_CODE]: code,
    },
})
    .then((response) => response.data);
export const getLinkedinOrganization = async (root, code) => axios
    .post(`${root}/legacy/social-media-bridge/linkedin-organization`, {
    accessToken: code,
})
    .then((response) => response.data);
export const linkedinShare = async (root, certificate, request) => axios
    .post(`${root}/legacy/social-media-bridge/linkedin/${certificate}`, request)
    .then((response) => response.data);
export const openGraphShare = async (root, certificate, request) => axios
    .post(`${root}/legacy/social-media-bridge/opengraph/${certificate}`, request)
    .then((response) => response.data);
//# sourceMappingURL=social-media-bridge.js.map